import script from "./TaxView.vue?vue&type=script&setup=true&lang=js"
export * from "./TaxView.vue?vue&type=script&setup=true&lang=js"

import "./TaxView.vue?vue&type=style&index=0&id=1063c6dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1063c6dd"]])

export default __exports__